import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, useHistory, useParams, useLocation } from 'react-router'
import { Card, CardHeader } from 'reactstrap'

import {
  course,
  resetCourse,
  fetchCourses,
  fetchSubmission,
  toggleFullscreen,
  fetchUserProgressByCourseId,
  finishContent,
} from 'store/Course/actions'

import * as courseActions from 'store/Course/actions'

import * as quizActions from 'store/Quiz/actions'

import Drawer from './drawer/Drawer'

import Quiz from '../../Quiz'
import ContentQuizView from '../../ContentQuiz'
import ViewPresentation from '../components/file/ViewFile'
import ViewVideo from '../components/video/ViewVideo'
import ViewScorm from '../components/scorm/ViewScorm'
import ViewHtml from '../components/html/ViewHtml'
import ViewText from '../components/text/ViewText'
import ViewSubtitle from '../components/subtitle/ViewSubtitle'
import ViewLti from '../components/lti/ViewLTI'
import CardsHeader from 'components/Headers/CardsHeader'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import { setInViewCourse } from 'store/Course/actions'
import { fetchCourseRating } from 'store/Course/actions'
import { fetchSelfAssignableCourses } from 'store/AllCourses/actions'
import { fetchSelfAssignedCourses } from 'store/AllCourses/actions'
import { getSelfCourseFeedbackData } from 'store/Course/actions'
import { setAllFeedbackData } from 'store/Course/actions'
import { setUserCertificationTime } from 'store/Course/actions'
import { Link } from 'react-router-dom'

// window.onpopstate = function () {
//   window.location.href = '/learning-plan';
// };

/*eslint-disable*/
const getType = (type) => {
  switch (type) {
    case 0:
      return 'subtitle'
    case 1:
      return 'text'
    case 2:
      return 'video'
    case 4:
      return 'file'
    case 5:
      return 'html'
    case 8:
      return 'scorm'
    case 9:
      return 'lti'
    case 10:
      return 'content-quiz'
  }
}
function Course() {
  const courseState = useSelector((state) => state.courses)
  const { isFullscreen, name: courseName } = courseState
  const language = useSelector((state) => state.language.language?.data)
  const access = useSelector((state) => state.auth.user.access)
  const user = useSelector((state) => state.auth.user)
  const userQuiz = useSelector((state) => state.quizes)
  const theme = useSelector((state) => state.themeConfig.theme)
  const general = useSelector((state) => state.generalConfig)

  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const [show, setShow] = useState(true)

  console.log(courseState, 'leart82')

  const [isShowing, setIsShowing] = useState(false)
  const makeFullscreen = () => {
    dispatch(toggleFullscreen(!isFullscreen))
    var el = document.documentElement
    function cancelFullScreen() {
      var el = document
      var requestMethod =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullscreen ||
        el.webkitExitFullscreen
      if (requestMethod) {
        // cancel full screen.
        requestMethod.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // Older IE.
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
    }

    function requestFullScreen(el) {
      // Supports most browsers and their versions.
      var requestMethod =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // Older IE.
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
      return false
    }

    function toggleFullScreen(el) {
      if (!el) {
        el = document.body // Make the body go full screen.
      }
      var isInFullScreen =
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        document.mozFullScreen ||
        document.webkitIsFullScreen

      if (isInFullScreen) {
        cancelFullScreen()
      } else {
        requestFullScreen(el)
      }
      return false
    }
    toggleFullScreen(el)
  }

  useEffect(() => {
    if (
      courseState.fetchedAllCourses &&
      !window.location.pathname.includes('quiz')
    ) {
      if (!courseState.courses.map((c) => c.course_id).includes(+id)) {
        history.push('/dashboard')
      }
    }
  }, [courseState.fetchedAllCourses, id, window.location.pathname])

  useEffect(() => {
    dispatch(setInViewCourse(true))
    // dispatch(setUserProgress(id, 1, false))
    dispatch(fetchCourseRating(id))
    dispatch(course(id))
    dispatch(fetchSelfAssignableCourses())
    dispatch(fetchSelfAssignedCourses())
    dispatch(getSelfCourseFeedbackData(id))
    dispatch(setAllFeedbackData(id))
    dispatch(fetchSubmission(id))

    dispatch(fetchUserProgressByCourseId(id))
    dispatch(fetchCourses())
    window.scrollTo(0, 0)

    return () => {
      dispatch(setInViewCourse(false))
      dispatch(resetCourse())
    }
  }, [])

  useEffect(() => {
    const { content } = courseState
    const { containerPosition } = courseState
    const firstContent = content.find((item) => item.position == 1)

    let notFound = false
    containerPosition.map((container, index) => {
      if (index === 0) {
        const findContent = content.filter(
          (item) => item.type === container.type,
        )[0]

        if (findContent) {
          history.push({
            pathname: `/course/${courseState?.id}/${getType(
              findContent.type,
            )}/${findContent.id}`,
          })
        } else {
          notFound = true
        }
      }
    })

    if (
      (!containerPosition.length || notFound) &&
      !location?.pathname?.split('/')?.at(4)
    ) {
      const firstContent = content[0]

      if (firstContent) {
        history.replace({
          pathname: `/course/${courseState?.id}/${getType(firstContent.type)}/${
            firstContent.id
          }`,
        })
      }
    }

    if (firstContent && firstContent?.type !== 2 && firstContent?.type !== 8) {
      dispatch(finishContent(courseState.id, firstContent.id))
    }
  }, [courseState.content.length, courseState.id])

  useEffect(() => {
    // setInterval only guarantees a minimum delay, not an exact one - browsers
    // throttle timers in background/inactive tabs, so a "10s" tick can actually
    // fire much later. Sending the real elapsed time (instead of assuming every
    // tick is exactly 10000ms) keeps certification_time accurate.
    let lastTick = Date.now()

    const intervalId = setInterval(() => {
      const now = Date.now()
      // Cap at a minute so a laptop sleep/suspend between ticks doesn't get
      // counted as active course time.
      const elapsed = Math.min(now - lastTick, 60000)
      lastTick = now
      dispatch(setUserCertificationTime(elapsed, courseState.id))
    }, 10000)

    return () => clearInterval(intervalId)
  }, [courseState.id, dispatch])

  const currentContentId = location?.pathname?.split('/')?.at(4)
  const currentContent = courseState?.content?.find(
    (content) => content?.id === +currentContentId,
  )
  const currentContentIndex = courseState?.content?.findIndex(
    (content) => content?.id === +currentContentId,
  )
  const nextContent = courseState?.content?.at(currentContentIndex + 1)

  useEffect(() => {
    // currentContent isn't resolved yet (course content still loading, e.g.
    // right after a refresh) - currentContentIndex would be -1 here, which
    // would otherwise slip past the type checks below and finish content
    // that hasn't actually been viewed.
    if (!currentContent) return

    if (
      currentContent.type !== 8 &&
      currentContent.type !== 2 &&
      currentContentIndex !== 0
    ) {
      if (
        (currentContent.type === 2 &&
          currentContentIndex === 0 &&
          currentContent.required &&
          !currentContent.content[0]?.videoType) ||
        currentContent.type === 10
      ) {
      } else {
        dispatch(finishContent(courseState?.id, currentContentId))
      }
    }
  }, [currentContent, currentContentIndex, courseState?.id, dispatch])

  return (
    <div className='leon'>
      <Card
        className={`col12 ${
          isFullscreen ? 'shadow-none ' : 'bg-secondary '
        } overflow-hidden `}
        style={{ minHeight: '90vh', maxHeight: '90vh', margin: 0 }}
      >
        <div className='position-relative px-0 course-container overflow-scroll'>
          <div
            className={`h-100 bg-white p-0 overFlowYScroll position-relative ${
              show && !isFullscreen && !courseState?.hideCourseSidebar
                ? 'col-lg-8 col-xl-9'
                : 'col-12'
            }`}
            style={{ overflowY: 'auto' }}
          >
            {nextContent && currentContent?.completed && (
              <Link
                to={`/course/${courseState?.course_id}/${getType(
                  nextContent?.type,
                )}/${nextContent?.id}`}
                className='position-absolute continueButton btn btn-info w-25 bottom-5'
                style={{
                  marginBottom: '-20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: '50',
                }}
              >
                Continue
              </Link>
            )}
            <Route
              path={`/course/${courseState.course_id}/video/:id`}
              render={(routeProps) => (
                <ViewVideo
                  {...courseState}
                  {...routeProps}
                  isShowing={isShowing}
                  isFullscreen={isFullscreen}
                />
              )}
            />
            <Route
              path={`/course/${courseState.course_id}/file/:id`}
              render={(routeProps) => (
                <ViewPresentation
                  // fetchTrackingByCourseContent={(}
                  {...courseState}
                  {...routeProps}
                />
              )}
            />
            <Route
              path={`/course/${courseState.course_id}/scorm/:id`}
              render={(routeProps) => (
                <ViewScorm
                  {...courseState}
                  {...routeProps}
                  user={user}
                  isShowing={isShowing}
                  isFullscreen={isFullscreen}
                  makeFullscreen={makeFullscreen}
                />
              )}
            />

            <Route
              path={`/course/${courseState.course_id}/html/:id`}
              render={(routeProps) => (
                <ViewHtml {...courseState} {...routeProps} />
              )}
            />
            <Route
              path={`/course/${courseState.course_id}/text/:id`}
              render={(routeProps) => (
                <ViewText {...courseState} {...routeProps} />
              )}
            />
            <Route
              path={`/course/${courseState.course_id}/subtitle/:id`}
              render={(routeProps) => (
                <ViewSubtitle {...courseState} {...routeProps} />
              )}
            />
            <Route
              path={`/course/${courseState.course_id}/lti/:id`}
              render={(routeProps) => (
                <ViewLti {...courseState} {...routeProps} />
              )}
            />
            <Route
              path={`/course/:id/quiz`}
              render={(routeProps) => (
                <Quiz
                  {...courseState}
                  {...routeProps}
                  {...quizActions}
                  {...userQuiz}
                  language={language}
                  dispatch={dispatch}
                  isSubmission={location.pathname.indexOf('submission') !== -1}
                />
              )}
            />

            <Route
              path={`/course/:id/content-quiz/:contentId`}
              render={(routeProps) => (
                <ContentQuizView
                  {...courseState}
                  {...courseActions}
                  {...routeProps}
                  // {...quizActions}
                  // {...userQuiz}
                  language={language}
                  dispatch={dispatch}
                  isSubmission={location.pathname.indexOf('submission') !== -1}
                />
              )}
            />

            <Route
              path={`/course/:id/submission`}
              render={(routeProps) => {
                return (
                  <Quiz
                    {...courseState}
                    {...routeProps}
                    {...quizActions}
                    {...userQuiz}
                    language={language}
                    dispatch={dispatch}
                    isSubmission={
                      location.pathname.indexOf('submission') !== -1
                    }
                  />
                )
              }}
            />
          </div>
          {courseState.content &&
            !isFullscreen &&
            !courseState?.hideCourseSidebar && (
              <Drawer
                show={show}
                setShow={setShow}
                course={courseState}
                access={access}
                userQuiz={userQuiz}
                theme={theme}
                user={user}
                general={general}
              />
            )}
        </div>
      </Card>
    </div>
  )
}

export default Course
